<template>
  <v-container
    :fluid="!authUser"
    class="pt-8"
    style="width: 1100px"
    :style="{
      'background-color': 'white',
      'padding-left': authUser ? '48px' : '40px',
    }"
  >
    <v-dialog v-model="mensajeDialog" max-width="350px">
      <v-card class="pb-2">
        <v-card-title class="text-h5">
          <v-icon
            class="fas fa-exclamation-triangle mr-2"
            small
            color="amber darken-2"
          ></v-icon>
          Completar Información
          <v-spacer></v-spacer>
          <v-icon
            class="fas fa-times"
            color="red"
            @click="mensajeDialog = false"
          ></v-icon>
        </v-card-title>
        <v-card-text>
          <p>
            Por favor, asegúrate de completar los siguientes campos. Si ya los
            has completado, puedes ignorar esta notificación.
          </p>
          <ul v-if="user == 'user'" class="subtitle-2">
            <li>DUI.</li>
            <li>Firma Afiliado. (Debe Guardar Su Firma)</li>
            <li>
              CALIDAD DE SERVICIO:
              <ul>
                <li>Calidad de Trabajo Realizado.</li>
                <li>Atención por Parte del {{ getNombreTipoOperador }}.</li>
                <li>Apariencia del {{ getNombreTipoOperador }}.</li>
                <li>Apariencia de la Unidad Enviada.</li>
                <li>
                  Observaciones
                  {{ compTextoObservaciones }}
                  (Afiliado). En caso de no contar con observaciones, por favor
                  coloque "Ninguna" en el campo correspondiente.
                </li>
              </ul>
            </li>
            <li>Finalmente, click en "Enviar Datos"</li>
          </ul>
          <ul v-else-if="user == 'operador'" class="subtitle-2">
            <li v-if="!esHogar">Placa Unidad.</li>
            <li>Punto de Salida.</li>
            <li>
              Observaciones
              {{ compTextoObservaciones }}
              (Técnico Vial). En caso de no contar con observaciones, por favor
              coloque "Ninguna" en el campo correspondiente.
            </li>
            <li v-if="asistencia.tipoServicio != 'TAXI' && !esHogar">
              Marcadores Vehiculo. (Debe Seleccionar Guardar Marcadores)
            </li>
            <li>
              Firma Operador. (Debe Guardar Su Firma y Luego Enviar Datos)
            </li>
            <li v-if="formulario.tipoFormularioProveedorId == 2">
              Si aplica
              <ul>
                <li>Nombre y Firma de Recibido Por. (Debe Guardar la Firma)</li>
                <li>Lugar donde se traslado el vehículo.</li>
                <li>Detalles del Vehiculo.</li>
              </ul>
            </li>
            <li>Finalmente, click en "Enviar Datos"</li>
          </ul>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>
    <!-- CONFIRM DIALOG -->
    <v-dialog v-model="confirmDialog" persistent max-width="375">
      <v-card>
        <v-card-title class="headline">
          {{ confirmTitle }}
        </v-card-title>
        <v-card-text class="body-2"> {{ confirmText }} </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-btn color="primary" outlined @click="confirmDialog = false">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="confirmAction"> Continuar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-form ref="form" lazy-validation>
      <v-row class="d-flex py-3">
        <v-col cols="12" md="2" class="pt-5 pl-8" style="max-width: 125px">
          <img src="../assets/logoAR.png" style="width: 60px" />
        </v-col>
        <v-col cols="12" md="10" style="max-width: 400px">
          <v-row class="subtitle-1 blue--text font-weight-bold lighten-1--text"
            >ASISTENCIA REGIONAL EL SALVADOR, S.A. DE C.V.
          </v-row>
          <v-row class="caption"
            >PBX: (503) 2508-4000, FAX: (503) 2508-4000
          </v-row>
          <v-row class="caption"
            >Final 87 Avenida Sur, Casa #4, Colonia Maquilishuat, San Salvador
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3" style="max-width: 300px" class="pb-0">
          <v-text-field
            class="pa-0 ma-0"
            label="Tipo de Servicio"
            v-model="asistencia.tipoServicio"
            hide-details
            readonly
          >
          </v-text-field>
        </v-col>
        <v-col v-if="authUser" class="pb-0"
          ><v-btn
            @click="printing"
            class="dont-print primary"
            style="max-width: 200px"
            >Imprimir <v-icon class="fas fa-print ml-2"></v-icon> </v-btn
        ></v-col>
      </v-row>
      <v-row class="px-3">
        <v-col cols="12" md="3" style="max-width: 280px">
          <v-row class="py-3 subtitle-2">DATOS DEL SERVICIO </v-row>
          <v-row class="d-flex flex-column">
            <v-text-field
              dense
              class="mb-2"
              hide-details
              label="N° Asistencia"
              v-model="asistencia.numeroAsistencia"
              readonly
            >
            </v-text-field>
            <v-text-field
              dense
              class="mb-2"
              hide-details
              label="Fecha"
              readonly
              v-model="asistencia.fecha"
            >
            </v-text-field>
            <v-text-field
              dense
              class="mb-2"
              hide-details
              label="Hora de Asignación"
              v-model="asistencia.horaAsignacion"
              readonly
            >
            </v-text-field>
            <v-text-field
              dense
              class="mb-2"
              hide-details
              label="Hora de Contacto"
              v-model="asistencia.horaContacto"
              readonly
            >
            </v-text-field>
            <v-text-field
              dense
              class="mb-2"
              hide-details
              label="Hora de Termino"
              v-model="asistencia.horaTermino"
              readonly
            >
            </v-text-field>
            <v-text-field
              dense
              class="mb-2"
              hide-details
              label="Cuenta"
              v-model="asistencia.cuenta"
              readonly
            >
            </v-text-field>
            <v-text-field
              dense
              class="mb-2"
              hide-details
              label="Direccion"
              v-model="asistencia.direccion"
            ></v-text-field>
          </v-row>
        </v-col>
        <v-col
          :class="{ 'mx-12': $vuetify.breakpoint.smAndUp }"
          style="max-width: 280px"
          cols="12"
          md="3"
        >
          <v-row class="py-3 subtitle-2">DATOS DEL AFILIADO </v-row>
          <v-row class="d-flex flex-column">
            <v-text-field
              class="mb-2"
              hide-details
              dense
              label="Afiliado"
              v-model="asistencia.afiliado"
              readonly
            >
            </v-text-field>
            <v-text-field
              class="mb-2"
              hide-details
              dense
              label="Conductor"
              v-model="asistencia.nombreConductor"
              readonly
              v-if="!esHogar"
            >
            </v-text-field>
            <v-text-field
              class="mb-2"
              hide-details
              dense
              label="DUI"
              v-mask="'########-#'"
              v-model="formulario.afiliadoDUI"
              :rules="user == 'user' ? requiredRule : []"
              :readonly="user != 'user' || enBase.afiliadoDUI || authUser"
            >
            </v-text-field>
            <v-text-field
              v-if="!esHogar"
              class="mb-2"
              hide-details
              dense
              label="Marca"
              v-model="asistencia.marca"
              readonly
            >
            </v-text-field>
            <v-text-field
              v-if="!esHogar"
              class="mb-2"
              hide-details
              dense
              label="Modelo"
              v-model="asistencia.modelo"
              readonly
            >
            </v-text-field>
            <v-text-field
              v-if="!esHogar"
              class="mb-2"
              hide-details
              dense
              label="Placa"
              v-model="asistencia.placa"
              readonly
            >
            </v-text-field>
            <v-text-field
              v-if="!esHogar"
              class="mb-2"
              hide-details
              dense
              label="Color"
              v-model="asistencia.color"
              readonly
            >
            </v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" md="3" style="max-width: 325px">
          <v-row class="py-3 subtitle-2">DATOS DE PROVEEDOR </v-row>
          <v-row class="d-flex flex-column">
            <v-text-field
              class="mb-2"
              hide-details
              dense
              label="Técnico"
              v-model="asistencia.tecnico"
              readonly
            >
            </v-text-field>
            <v-text-field
              class="mb-2"
              hide-details
              v-if="!esHogar"
              dense
              label="Placa de Unidad"
              v-model="formulario.placaProveedor"
              :rules="user == 'operador' ? requiredRule : []"
              :readonly="enBase.placaProveedor || validarUserOperador"
            >
            </v-text-field>
            <v-text-field
              class="mb-2"
              hide-details
              dense
              label="Punto de Salida"
              v-model="formulario.puntoSalidaProveedor"
              :rules="user == 'operador' ? requiredRule : []"
              :readonly="enBase.puntoSalidaProveedor || validarUserOperador"
            >
            </v-text-field>
            <v-text-field
              v-if="formulario.tipoFormularioProveedorId == 2"
              class="mb-2"
              dense
              hide-details
              v-model="formulario.nombreRecibidoUnidad"
              label="Nombre Recibido Por"
              :rules="
                user == 'operador' && formulario.tipoFormularioProveedorId == 2
                  ? requiredRule
                  : []
              "
              :readonly="enBase.nombreRecibidoUnidad || validarUserOperador"
            ></v-text-field>
            <v-textarea
              v-model.trim="formulario.observacionesTecnico"
              class="mt-2"
              no-resize
              outlined
              hide-details
              dense
              :rules="user == 'operador' ? requiredRule : []"
              :label="textObservacionesTecnico"
              :readonly="enBase.observacionesTecnico || validarUserOperador"
            ></v-textarea>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="px-3">
        <v-col cols="12" md="3" class="py-0" style="max-width: 300px">
          <v-row class="pb-2 pt-0" v-if="!esHogar"
            >DESCRIPCION DEL SERVICIO</v-row
          >
          <v-row class="d-flex flex-column" v-if="!esHogar">
            <v-text-field
              class="pa-0 ma-0"
              dense
              label="Motivo del Servicio"
              v-model="asistencia.motivoServicio"
              readonly
            >
            </v-text-field>
            <v-text-field
              class="pa-0 ma-0"
              v-model="asistencia.lugarVehiculo"
              :label="
                asistencia.tipoServicio == 'TAXI'
                  ? 'Lugar donde se encuentra el Afiliado'
                  : 'Lugar donde se encontraba el vehículo'
              "
            ></v-text-field>
            <v-text-field
              v-if="
                formulario.tipoFormularioProveedorId == 2 ||
                  asistencia.tipoServicio == 'TAXI'
              "
              class="pa-0 ma-0"
              v-model="formulario.lugarTrasladoVehiculo"
              :rules="
                user == 'operador' && formulario.tipoFormularioProveedorId == 2
                  ? requiredRule
                  : []
              "
              :label="
                asistencia.tipoServicio == 'TAXI'
                  ? 'Lugar Destino'
                  : 'Lugar donde se traslado el vehículo'
              "
              :readonly="enBase.lugarTrasladoVehiculo || validarUserOperador"
            ></v-text-field>
          </v-row>
          <v-row class="pb-2 pt-0 mt-4">CALIDAD DEL SERVICIO</v-row>
          <v-row class="d-flex flex-column">
            <v-select
              v-model="calidadFormularioProveedor.calidadTrabajo"
              class="pa-0 ma-0"
              :items="opcionesCalidad"
              label="Calidad de Trabajo Realizado"
              :disabled="user != 'user' || enBase.calidadTrabajo || authUser"
              :rules="user == 'user' ? requiredRule : []"
              dense
            ></v-select>
            <v-select
              v-model="calidadFormularioProveedor.atencion"
              class="pa-0 ma-0"
              :items="opcionesCalidad"
              :label="`Atención por Parte del ${getNombreTipoOperador}`"
              :rules="user == 'user' ? requiredRule : []"
              dense
              :disabled="user != 'user' || enBase.atencion || authUser"
            ></v-select>
            <v-select
              v-model="calidadFormularioProveedor.aparienciaOperador"
              :rules="user == 'user' ? requiredRule : []"
              class="pa-0 ma-0"
              :items="opcionesCalidad"
              :label="`Apariencia del ${getNombreTipoOperador}`"
              dense
              :disabled="
                user != 'user' || enBase.aparienciaOperador || authUser
              "
            ></v-select>
            <v-select
              v-if="!esHogar"
              v-model="calidadFormularioProveedor.aparienciaUnidad"
              :rules="user == 'user' ? requiredRule : []"
              :items="opcionesCalidad"
              :label="
                asistencia.tipoServicio == 'TAXI'
                  ? 'Apariencia del vehículo'
                  : 'Apariencia de la Unidad Enviada'
              "
              dense
              :disabled="user != 'user' || enBase.aparienciaUnidad || authUser"
              class="pa-0 ma-0"
            ></v-select>
          </v-row>
          <v-row class="d-flex flex-column">
            <v-col class="pa-0">
              <v-textarea
                v-model.trim="formulario.observacionesAfiliado"
                no-resize
                outlined
                dense
                hide-details
                :rules="user == 'user' ? requiredRule : []"
                :readonly="
                  user != 'user' || enBase.observacionesAfiliado || authUser
                "
                :label="textoObservacionesAfiliado"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-if="asistencia.tipoServicio != 'TAXI' && !esHogar"
          :class="{ 'ml-12 mr-3 pl-2': $vuetify.breakpoint.smAndUp }"
          style="max-width: 300px"
          cols="12"
          md="3"
        >
          <v-row>
            <VehiclePartsMarker
              :state="formulario.marcadoresVehiculo || null"
              :disabled="enBase.marcadores || validarUserOperador"
              @marker-state="formulario.marcadoresVehiculo = $event"
            />
          </v-row>
          <v-btn
            v-if="user == 'operador' && !enBase.marcadores"
            class="mt-3 ml-0"
            :disabled="
              !formulario.marcadoresVehiculo ||
                formulario.marcadoresVehiculo.markers.length == 0
            "
            color="primary"
            @click="showConfirmMarcadores"
            >Guardar Marcadores</v-btn
          >
          <v-row class="mt-3 subtitle-2">CÓDIGO DE IDENTIFICACIÓN </v-row>
          <v-row class="caption">
            <v-col class="pa-0 ma-0">
              <v-icon class="far fa-star" small color="red"></v-icon> : QUEBRADO
            </v-col>
            <v-col class="pa-0 ma-0">
              <svg
                fill="#ff0000"
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="18px"
                height="16px"
                viewBox="0 0 72.72 72.719"
                xml:space="preserve"
                stroke="#ff0000"
                stroke-width="0.7272000000000001"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke="#CCCCCC"
                  stroke-width="0.14543999999999999"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <g>
                    <g>
                      <path
                        d="M72.72,65.686H0L36.36,7.034L72.72,65.686z M5.388,62.686h61.943L36.36,12.727L5.388,62.686z"
                      ></path>
                    </g>
                  </g>
                </g>
              </svg>
              : GOLPE
            </v-col>
          </v-row>
          <v-row class="caption">
            <v-col class="pa-0 ma-0">
              <v-icon class="fas fa-circle" small color="red"></v-icon> : RAYÓN
            </v-col>
            <v-col class="pa-0 ma-0">
              <v-icon class="far fa-square" small color="red"></v-icon> :
              FALTANTE
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="3" style="max-width: 300px">
          <v-row class="py-0 my-0" v-if="!esHogar">
            <v-row class="py-0 subtitle-2">DATOS TERCERO</v-row>
            <v-row class="d-flex flex-row py-1">
              <v-row>
                <v-col>
                  <v-text-field
                    class="my-0"
                    hide-details
                    dense
                    label="Placa"
                    v-model="tercero.placa"
                    readonly
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    class="my-0"
                    hide-details
                    dense
                    label="Marca"
                    v-model="tercero.marca"
                    readonly
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <v-text-field
                class="my-0"
                hide-details
                dense
                label="Modelo"
                v-model="tercero.modelo"
                readonly
              >
              </v-text-field>

              <v-row>
                <v-col>
                  <v-text-field
                    class="my-0"
                    hide-details
                    dense
                    label="Color"
                    v-model="tercero.color"
                    readonly
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    class="my-0"
                    hide-details
                    dense
                    label="Año"
                    v-model="tercero.año"
                    readonly
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-row>
          </v-row>
          <v-row
            v-if="formulario.tipoFormularioProveedorId == 2"
            class="d-flex flex-column"
            style="max-width: 300px"
          >
            <v-switch
              v-model="detalleFormularioProveedor.llantaRepuesto"
              inset
              color="blue"
              label="Llanta de Repuesto"
              class="pa-0 ma-0"
              hide-details
              dense
              :readonly="enBase.llantaRepuesto || validarUserOperador"
            ></v-switch>
            <v-row class="py-0 my-0">
              <v-col class="py-1">
                <v-switch
                  v-model="detalleFormularioProveedor.llaveDeRuedas"
                  inset
                  color="blue"
                  class="pa-0 ma-0"
                  hide-details
                  dense
                  label="Llave de Ruedas"
                  :readonly="enBase.llaveDeRuedas || validarUserOperador"
                ></v-switch>
              </v-col>
              <v-col cols="3" class="pa-0 ma-0"
                ><v-text-field
                  class="pa-0 ma-0"
                  hide-details
                  dense
                  label="Cantidad"
                  v-mask="'##'"
                  v-model="detalleFormularioProveedor.cantidadLlaveDeRuedas"
                  :readonly="
                    enBase.cantidadLlavesDeRueda || validarUserOperador
                  "
                >
                </v-text-field
              ></v-col>
            </v-row>
            <v-switch
              v-model="detalleFormularioProveedor.mica"
              inset
              color="blue"
              class="pa-0 ma-0"
              hide-details
              dense
              label="Mica"
              :readonly="enBase.mica || validarUserOperador"
            ></v-switch>
            <v-row class="py-0 my-0">
              <v-col class="py-1">
                <v-switch
                  v-model="detalleFormularioProveedor.herramientas"
                  inset
                  color="blue"
                  class="pa-0 ma-0"
                  hide-details
                  dense
                  label="Herramientas"
                  :readonly="enBase.herramientas || validarUserOperador"
                ></v-switch>
              </v-col>
              <v-col cols="3" class="pa-0 ma-0"
                ><v-text-field
                  class="pa-0 ma-0"
                  hide-details
                  dense
                  label="Cantidad"
                  v-mask="'##'"
                  v-model="detalleFormularioProveedor.cantidadHerramientas"
                  :readonly="enBase.cantidadHerramientas || validarUserOperador"
                >
                </v-text-field
              ></v-col>
            </v-row>
            <v-switch
              v-model="detalleFormularioProveedor.espejoExterior"
              inset
              color="blue"
              class="pa-0 ma-0"
              hide-details
              dense
              label="Espejo Exterior"
              :readonly="enBase.espejoExterior || validarUserOperador"
            ></v-switch>
            <v-row class="py-0 my-0">
              <v-col class="py-1">
                <v-switch
                  v-model="detalleFormularioProveedor.emblemas"
                  inset
                  color="blue"
                  class="pa-0 ma-0"
                  hide-details
                  dense
                  label="Emblemas"
                  :readonly="enBase.emblemas || validarUserOperador"
                ></v-switch> </v-col
              ><v-col cols="3" class="pa-0 ma-0"
                ><v-text-field
                  hide-details
                  dense
                  label="Cantidad"
                  v-mask="'##'"
                  v-model="detalleFormularioProveedor.cantidadEmblemas"
                  :readonly="enBase.cantidadEmblemas || validarUserOperador"
                >
                </v-text-field
              ></v-col>
            </v-row>
            <v-switch
              v-model="detalleFormularioProveedor.radio"
              inset
              color="blue"
              class="pa-0 ma-0"
              hide-details
              dense
              label="Radio"
              :readonly="enBase.radio || validarUserOperador"
            ></v-switch>
            <v-switch
              v-model="detalleFormularioProveedor.caratula"
              inset
              color="blue"
              class="pa-0 ma-0"
              hide-details
              dense
              label="Caratula"
              :readonly="enBase.caratula || validarUserOperador"
            ></v-switch>
            <v-switch
              v-model="detalleFormularioProveedor.antena"
              inset
              color="blue"
              class="pa-0 ma-0"
              hide-details
              dense
              label="Antena"
              :readonly="enBase.antena || validarUserOperador"
            ></v-switch>
            <v-switch
              v-model="detalleFormularioProveedor.cajasDeRuedas"
              inset
              color="blue"
              class="pa-0 ma-0"
              hide-details
              dense
              label="Cajas de Ruedas"
              :readonly="enBase.cajasDeRuedas || validarUserOperador"
            ></v-switch>
            <v-row class="py-0 my-0">
              <v-col class="py-1">
                <v-switch
                  v-model="detalleFormularioProveedor.llaves"
                  inset
                  color="blue"
                  class="pa-0 ma-0"
                  hide-details
                  dense
                  label="Llaves"
                  :readonly="enBase.llaves || validarUserOperador"
                ></v-switch> </v-col
              ><v-col cols="3" class="pa-0 ma-0"
                ><v-text-field
                  class="pa-0 ma-0"
                  hide-details
                  dense
                  label="Cantidad"
                  v-mask="'##'"
                  v-model="detalleFormularioProveedor.cantidadLlaves"
                  :readonly="enBase.cantidadLlaves || validarUserOperador"
                >
                </v-text-field
              ></v-col>
            </v-row>
            <v-switch
              v-model="detalleFormularioProveedor.tarjeta"
              inset
              color="blue"
              class="pa-0 ma-0"
              hide-details
              dense
              label="Tarjeta"
              :readonly="enBase.tarjeta || validarUserOperador"
            ></v-switch>
            <v-row class="py-0 my-0">
              <v-col class="py-1">
                <v-switch
                  v-model="detalleFormularioProveedor.placas"
                  inset
                  color="blue"
                  class="pa-0 ma-0"
                  hide-details
                  dense
                  label="Placas"
                  :readonly="enBase.placas || validarUserOperador"
                ></v-switch> </v-col
              ><v-col cols="3" class="pa-0 ma-0"
                ><v-text-field
                  class="pa-0 ma-0"
                  hide-details
                  dense
                  label="Cantidad"
                  v-mask="'##'"
                  v-model="detalleFormularioProveedor.cantidadPlacas"
                  :readonly="enBase.cantidadPlacas || validarUserOperador"
                >
                </v-text-field
              ></v-col>
            </v-row>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
    <v-row
      class="pt-4 pb-4 pl-3 mt-0"
      :style="{
        'max-width': $vuetify.breakpoint.smAndDown ? '300px' : '1000px',
      }"
    >
      <h1 class="subtitle-2">Firma de Responsabilidad</h1>
      <span class="caption">{{ textoResponsabilidad }}</span>
    </v-row>
    <v-row class="pt-0 mt-0">
      <v-col
        style="max-width: 300px"
        :class="{ 'pt-0 mt-0 pl-6': $vuetify.breakpoint.mdAndUp }"
      >
        <SignatureCanvas
          ref="fAfiliado"
          v-if="formulario.formularioProveedorId"
          :points="formulario.firmaAfiliado"
          type="AFILIADO"
          :disabled="user != 'user'"
          :formularioProveedorId="formulario.formularioProveedorId"
          @updated-sign="formulario.firmaAfiliado = $event"
        />
      </v-col>
      <v-col
        class="pt-0 mt-0"
        style="max-width: 325px"
        :class="{ 'pl-5 ml-7': $vuetify.breakpoint.smAndUp }"
      >
        <SignatureCanvas
          ref="fProveedor"
          v-if="formulario.formularioProveedorId"
          :points="formulario.firmaOperadorUnidad"
          type="OPERADOR"
          :disabled="user != 'operador'"
          :formularioProveedorId="formulario.formularioProveedorId"
          @updated-sign="formulario.firmaOperadorUnidad = $event"
        />
      </v-col>
      <v-col
        class="pt-0 mt-0"
        :class="{ 'pl-2 ml-4': $vuetify.breakpoint.smAndUp }"
      >
        <SignatureCanvas
          ref="fRecibido"
          v-if="
            formulario.formularioProveedorId &&
              formulario.tipoFormularioProveedorId == 2
          "
          :points="formulario.firmaRecibidoUnidad"
          type="RECIBIDO"
          :disabled="user != 'operador'"
          :formularioProveedorId="formulario.formularioProveedorId"
          @updated-sign="formulario.firmaRecibidoUnidad = $event"
        />
      </v-col>
    </v-row>
    <v-row v-if="user && informacionSinGuardar">
      <v-col class="pb-0 mb-1">
        <v-btn color="primary" @click="showConfirmDatos" class="dont-print"
          >Enviar Datos</v-btn
        >
      </v-col></v-row
    >
    <v-row
      class="pt-0 pb-4 pl-3 mt-0"
      :style="{
        'max-width': $vuetify.breakpoint.smAndDown ? '300px' : '1000px',
      }"
    >
      <span class="headline subtitle-2"
        >ASISTENCIA REGIONAL, EL SALVADOR, S.A. DE C.V., SE DESLIGA DE TODA
        RESPONSABILIDAD DERIVADA E ILÍCITOS O INFRACCIONES DE LEY COMETIDAS POR
        EL PROVEEDOR Y ASEGURADO / CONDUCTOR AUTORIZADO.</span
      >
    </v-row>
  </v-container>
</template>
<script>
import axios from "axios";
import router from "../router";
import VehiclePartsMarker from "./VehiclePartsMarker.vue";
import SignatureCanvas from "./SignatureCanvas.vue";
import VueHtml2pdf from "vue-html2pdf";

export default {
  name: "FormularioFirma",
  components: { VehiclePartsMarker, SignatureCanvas, VueHtml2pdf },
  data: () => ({
    confirmTitle: "Confirmación Marcadores",
    confirmText:
      "Esta acción es irreversible, si selecciona continuar no podrá realizar cambios en los marcadores.",
    confirmState: "marcadores",
    snack: false,
    snackColor: "primary",
    snackText: "",
    snackTime: 4000,
    confirmDialog: false,
    mensajeDialog: false,
    requiredRule: [(v) => !!v || "Campo Requerido"],
    listadoHogar: [
      "FONTANERIA HOGAR",
      "CERRAJERIA HOGAR",
      "ARMADO DE MUEBLES",
      "ELECTRICIDAD HOGAR",
    ],
    enBase: {
      afiliadoDUI: false,
      calidadTrabajo: false,
      atencion: false,
      aparienciaOperador: false,
      aparienciaUnidad: false,
      observacionesAfiliado: false,
      placaProveedor: false,
      puntoSalidaProveedor: false,
      lugarTrasladoVehiculo: false,
      observacionesTecnico: false,
      nombreRecibidoUnidad: false,
      llantaRepuesto: false,
      llaveDeRuedas: false,
      herramientas: false,
      espejoExterior: false,
      emblemas: false,
      radio: false,
      caratula: false,
      antena: false,
      cajasDeRuedas: false,
      llaves: false,
      mica: false,
      marcadores: null,
      tarjeta: false,
      placas: false,
      cantidadLlavesDeRueda: false,
      cantidadHerramientas: false,
      cantidadEmblemas: false,
      cantidadLlaves: false,
      cantidadPlacas: false,
    },
    opcionesCalidad: ["EXCELENTE", "REGULAR", "MALA"],
    asistencia: {
      tipoServicio: "",
      numeroAsistencia: "",
      fecha: "",
      horaAsignacion: "",
      horaContacto: "",
      horaTermino: "",
      cuenta: "",
      direccion: "",
      afiliado: "",
      nombreConductor: "",
      dui: "",
      placa: "",
      marca: "",
      modelo: "",
      color: "",
      tecnico: "",
      placaProveedor: null,
      puntoSalidaProveedor: null,
      motivoServicio: "",
      lugarVehiculo: "",
      obsAfiliado: "",
      obsTecnico: "",
      tipoFormularioProveedorId: null,
      marcadoresVehiculo: null,
      firmaAfiliado: "",
      firmaOperadorUnidad: "",
      firmaReciboUnidad: "",
      nombreReciboUnidad: "",
    },
    user: null,
    calidadFormularioProveedor: {
      calidadServicioId: null,
      calidadTrabajo: null,
      atencion: null,
      aparienciaOperador: null,
      aparienciaUnidad: null,
    },
    detalleFormularioProveedor: {
      detalleFormularioProveedorId: null,
      llantaRepuesto: false,
      llaveDeRuedas: false,
      herramientas: false,
      espejoExterior: false,
      emblemas: false,
      radio: false,
      caratula: false,
      antena: false,
      cajasDeRuedas: false,
      llaves: false,
      mica: false,
      tarjeta: false,
      placas: false,
      cantidadLlaveDeRuedas: 0,
      cantidadHerramientas: 0,
      cantidadEmblemas: 0,
      cantidadLlaves: 0,
      cantidadPlacas: 0,
    },
    formulario: {
      formularioProveedorId: null,
      afiliadoDUI: null,
      placaProveedor: null,
      puntoSalidaProveedor: null,
      lugarTrasladoVehiculo: null,
      marcadoresVehiculo: null,
      tipoFormularioProveedorId: null,
      firmaOperadorUnidad: null,
      firmaAfiliado: null,
      firmaRecibidoUnidad: null,
      nombreRecibidoUnidad: null,
      calidadServicioId: null,
      observacionesAfiliado: null,
      observacionesTecnico: null,
      numeroAsistencia: "",
      detalleFormularioProveedorId: null,
      tipoFormularioProveedor: null,
      codigoAfiliado: null,
      codigoOperadorUnidad: null,
      codigoRecibidoUnidad: null,
    },
    tercero: {
      marca: "",
      modelo: "",
      color: "",
      placa: "",
      año: "",
    },
  }),
  computed: {
    esHogar() {
      return this.listadoHogar.includes(this.asistencia.tipoServicio);
    },
    textObservacionesTecnico() {
      const checkHogar = this.listadoHogar.includes(
        this.asistencia.tipoServicio,
      );
      if (this.asistencia.tipoServicio == "TAXI") {
        return "Observaciones del Servicio";
      } else if (checkHogar) {
        return "Observaciones";
      } else {
        return "Observaciones Siniestro (Técnico Vial)";
      }
    },
    textoObservacionesAfiliado() {
      const checkHogar = this.listadoHogar.includes(
        this.asistencia.tipoServicio,
      );
      if (this.asistencia.tipoServicio == "TAXI") {
        return "Observaciones del Servicio (Afiliado)";
      } else if (checkHogar) {
        return "Observaciones";
      } else {
        return "Observaciones Siniestro (Afiliado)";
      }
    },
    compTextoObservaciones() {
      const checkHogar = this.listadoHogar.includes(
        this.asistencia.tipoServicio,
      );
      if (this.asistencia.tipoServicio == "TAXI" || checkHogar) {
        return "Del Servicio";
      } else {
        return "Siniestro";
      }
    },
    textoResponsabilidad() {
      const checkHogar = this.listadoHogar.includes(
        this.asistencia.tipoServicio,
      );
      if (checkHogar) {
        return "Manifiesto que he revisado y recibido el servicio detallado en la parte superior de este documento, en las condiciones que yo solicité, por lo que confirmo que no tengo ningún reclamo actual ni futuro por el mismo. En caso de haber alguna manipulación dentro de las coberturas no establecidas, autorizo al técnico a realizarla bajo mi responsabilidad expresa.";
      } else {
        return "Manifiesto que he revisado y recibido el vehículo detallado en la parte superior de este documento en las mismas condiciones, que se encontraba previo al traslado y de igual forma que he retirado todos los objetos personales del vehículo, por lo que confirmo que no tengo ningún reclamo actual ni futuro por el mismo. En caso de haber maniobras de riesgo, autorizo al operador de la unidad a realizarla bajo mi responsabilidad expresa.";
      }
    },
    getNombreTipoOperador() {
      if (this.formulario.tipoFormularioProveedorId == 1) {
        if (this.asistencia.tipoServicio == "TAXI") {
          return "Conductor";
        } else {
          return "Operador";
        }
      } else {
        return "Operador de la Grúa";
      }
    },
    validarUserOperador() {
      return (
        this.user != "operador" ||
        (this.authUser && this.$store.state.usuario.rol != "Operador Grua")
      );
    },
    authUser() {
      return !!this.$store.state.token;
    },
    informacionSinGuardar() {
      if (!this.user) {
        return false;
      }

      const requiredFields = {
        user: [
          "afiliadoDUI",
          "calidadTrabajo",
          "atencion",
          "aparienciaOperador",
          "aparienciaUnidad",
          "observacionesAfiliado",
        ],
        operador:
          this.formulario.tipoFormularioProveedorId == 1
            ? ["placaProveedor", "puntoSalidaProveedor", "observacionesTecnico"]
            : [
                "placaProveedor",
                "puntoSalidaProveedor",
                "observacionesTecnico",
                "lugarTrasladoVehiculo",
                "llantaRepuesto",
                "llaveDeRuedas",
                "herramientas",
                "espejoExterior",
                "emblemas",
                "radio",
                "caratula",
                "antena",
                "cajasDeRuedas",
                "llaves",
                "mica",
                "marcadores",
                "tarjeta",
                "placas",
                "nombreRecibidoUnidad",
                "cantidadLlavesDeRueda",
                "cantidadHerramientas",
                "cantidadEmblemas",
                "cantidadLlaves",
                "cantidadPlacas",
              ],
      };

      const campos = requiredFields[this.user];
      const camposCompletos = campos.every(
        (campo) => this.enBase[campo] == true,
      );

      return !camposCompletos;
    },
  },
  created() {
    const numAsistencia = this.$route.params.numAsistencia;
    this.getAsistencia(numAsistencia);
  },
  mounted() {},
  methods: {
    printing() {
      window.print();
    },
    confirmAction() {
      if (this.confirmState == "marcadores") {
        this.guardarMarcadores();
      } else if (this.confirmState == "datos") {
        this.update();
      }
    },
    showConfirmMarcadores() {
      this.confirmState = "marcadores";
      this.confirmTitle = "Confirmación de Marcadores";
      this.confirmText =
        "Esta acción es irreversible, si selecciona continuar no podrá realizar cambios en los marcadores.";
      this.confirmDialog = true;
    },
    showConfirmDatos() {
      this.confirmState = "datos";
      this.confirmTitle = "Confirmación de Datos";
      this.confirmText =
        "Esta acción es irreversible, si selecciona continuar no podrá realizar cambios en los datos ingresados.";
      this.confirmDialog = true;
    },
    update() {
      if (this.$refs.form.validate()) {
        let sinFirmas = true;

        if (this.user == "user") {
          sinFirmas = this.$refs.fAfiliado.checkIsEmpty();
        } else {
          sinFirmas = false;
        }

        if (sinFirmas) {
          this.snackText = "Debe Colocar Una Firma";
          this.snackColor = "error";
          this.snack = true;

          this.confirmDialog = false;
          return;
        } else {
          if (this.user == "user") {
            if (!this.formulario.firmaAfiliado) {
              this.$refs.fAfiliado.uploadSignature();
            }
          }
        }

        axios
          .put(
            `api/FormularioFirma/${this.asistencia.numeroAsistencia}/Informacion`,
            {
              afiliadoDUI: this.formulario.afiliadoDUI,
              observacionesAfiliado: this.formulario.observacionesAfiliado,
              placaProveedor: this.formulario.placaProveedor,
              puntoSalidaProveedor: this.formulario.puntoSalidaProveedor,
              observacionesTecnico: this.formulario.observacionesTecnico,
              lugarTrasladoVehiculo: this.formulario.lugarTrasladoVehiculo,
              calidadTrabajo: this.calidadFormularioProveedor.calidadTrabajo,
              aparienciaOperador: this.calidadFormularioProveedor
                .aparienciaOperador,
              aparienciaUnidad: this.esHogar
                ? "EXCELENTE"
                : this.calidadFormularioProveedor.aparienciaUnidad,
              atencion: this.calidadFormularioProveedor.atencion,
              radio: !!this.detalleFormularioProveedor.radio,
              caratula: !!this.detalleFormularioProveedor.caratula,
              tarjeta: !!this.detalleFormularioProveedor.tarjeta,
              placas: !!this.detalleFormularioProveedor.placas,
              mica: !!this.detalleFormularioProveedor.mica,
              antena: !!this.detalleFormularioProveedor.antena,
              cajasDeRuedas: !!this.detalleFormularioProveedor.cajasDeRuedas,
              emblemas: !!this.detalleFormularioProveedor.emblemas,
              espejoExterior: !!this.detalleFormularioProveedor.espejoExterior,
              herramientas: !!this.detalleFormularioProveedor.herramientas,
              llantaRepuesto: !!this.detalleFormularioProveedor.llantaRepuesto,
              llaveDeRuedas: !!this.detalleFormularioProveedor.llaveDeRuedas,
              llaves: !!this.detalleFormularioProveedor.llaves,
              nombreRecibidoUnidad: this.formulario.nombreRecibidoUnidad,
              CantidadLlaveDeRuedas: this.detalleFormularioProveedor
                .cantidadLlaveDeRuedas
                ? this.detalleFormularioProveedor.cantidadLlaveDeRuedas
                : 0,
              cantidadHerramientas: this.detalleFormularioProveedor
                .cantidadHerramientas
                ? this.detalleFormularioProveedor.cantidadHerramientas
                : 0,
              cantidadEmblemas: this.detalleFormularioProveedor.cantidadEmblemas
                ? this.detalleFormularioProveedor.cantidadEmblemas
                : 0,
              cantidadLlaves: this.detalleFormularioProveedor.cantidadLlaves
                ? this.detalleFormularioProveedor.cantidadLlaves
                : 0,
              cantidadPlacas: this.detalleFormularioProveedor.cantidadPlacas
                ? this.detalleFormularioProveedor.cantidadPlacas
                : 0,
            },
          )
          .then((res) => {
            this.getAsistencia(this.asistencia.numeroAsistencia, false);

            this.snackText = "Datos Actualizados!";
            this.snackColor = "primary";
            this.snack = true;
          })
          .catch((err) => {
            this.snackText = "Los Datos no Fueron Actualizados!";
            this.snackColor = "error";
            this.snack = true;
            console.error(err.response);
          })
          .finally(() => {
            this.confirmDialog = false;
          });
      } else {
        this.confirmDialog = false;
        this.snackText = "Debe Completar los Datos...";
        this.snackColor = "error";
        this.snack = true;
      }
    },
    guardarMarcadores() {
      const marcadores = JSON.stringify(this.formulario.marcadoresVehiculo);

      axios
        .put(
          `api/FormularioFirma/${this.asistencia.numeroAsistencia}`,
          marcadores,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        )
        .then((res) => {
          this.snackText = "Marcadores Guardados Correctamente!";
          this.snackColor = "primary";
          this.snack = true;

          this.enBase.marcadores = !!this.formulario.marcadoresVehiculo;
        })
        .catch((err) => {
          console.log(err.response);

          this.snackText = "No se Pudo Guardar los Marcadores!";
          this.snackColor = "error";
          this.snack = true;
        })
        .finally(() => (this.confirmDialog = false));
    },
    checkUserType() {
      const query = this.$route.query.c;

      //Validacion solo para Operadores de Grua
      if (this.authUser) {
        if (this.$store.state.usuario.rol == "Operador Grua") {
          return "operador";
        } else {
          return null;
        }
      }

      if (query) {
        if (this.formulario.codigoAfiliado == query.toLowerCase()) {
          return "user";
        } else if (
          this.formulario.codigoOperadorUnidad == query.toLowerCase()
        ) {
          return "operador";
        } else if (
          this.formulario.codigoRecibidoUnidad == query.toLowerCase()
        ) {
          return "recibido";
        }
      }

      return null;
    },
    checkEnBase() {
      //AFILIADO
      this.enBase.afiliadoDUI = !!this.formulario.afiliadoDUI;
      this.enBase.observacionesAfiliado = !!this.formulario
        .observacionesAfiliado;

      //PROVEEDOR
      this.enBase.placaProveedor = this.esHogar
        ? true
        : !!this.formulario.placaProveedor;
      this.enBase.puntoSalidaProveedor = !!this.formulario.puntoSalidaProveedor;
      this.enBase.observacionesTecnico = !!this.formulario.observacionesTecnico;
      this.enBase.lugarTrasladoVehiculo =
        this.formulario.tipoFormularioProveedorId == 1 &&
        this.asistencia.tipoServicio != "TAXI"
          ? true
          : !!this.formulario.lugarTrasladoVehiculo;
      this.enBase.marcadores = !!this.formulario.marcadoresVehiculo;

      // RECIBIDO UNIDAD
      this.enBase.nombreRecibidoUnidad =
        this.formulario.tipoFormularioProveedorId == 1
          ? true
          : !!this.formulario.nombreRecibidoUnidad;

      //ENCUESTA
      this.enBase.aparienciaOperador = !!this.calidadFormularioProveedor
        .aparienciaOperador;
      this.enBase.aparienciaUnidad = this.esHogar
        ? true
        : !!this.calidadFormularioProveedor.aparienciaUnidad;
      this.enBase.atencion = !!this.calidadFormularioProveedor.atencion;
      this.enBase.calidadTrabajo = !!this.calidadFormularioProveedor
        .calidadTrabajo;

      //DETALLES REMOLQUE
      this.enBase.antena =
        this.detalleFormularioProveedor.antena != null ? true : false;
      this.enBase.cajasDeRuedas =
        this.detalleFormularioProveedor.cajasDeRuedas != null ? true : false;
      this.enBase.caratula =
        this.detalleFormularioProveedor.caratula != null ? true : false;
      this.enBase.cajasDeRuedas =
        this.detalleFormularioProveedor.cajasDeRuedas != null ? true : false;
      this.enBase.emblemas =
        this.detalleFormularioProveedor.emblemas != null ? true : false;
      this.enBase.espejoExterior =
        this.detalleFormularioProveedor.espejoExterior != null ? true : false;
      this.enBase.herramientas =
        this.detalleFormularioProveedor.herramientas != null ? true : false;
      this.enBase.llantaRepuesto =
        this.detalleFormularioProveedor.llantaRepuesto != null ? true : false;
      this.enBase.llaveDeRuedas =
        this.detalleFormularioProveedor.llaveDeRuedas != null ? true : false;
      this.enBase.llaves =
        this.detalleFormularioProveedor.llaves != null ? true : false;
      this.enBase.mica =
        this.detalleFormularioProveedor.mica != null ? true : false;
      this.enBase.placas =
        this.detalleFormularioProveedor.placas != null ? true : false;
      this.enBase.radio =
        this.detalleFormularioProveedor.radio != null ? true : false;
      this.enBase.tarjeta =
        this.detalleFormularioProveedor.tarjeta != null ? true : false;
      this.enBase.cantidadEmblemas =
        this.detalleFormularioProveedor.cantidadEmblemas == 0 ||
        this.detalleFormularioProveedor.cantidadEmblemas != null
          ? true
          : false;
      this.enBase.cantidadHerramientas =
        this.detalleFormularioProveedor.cantidadHerramientas == 0 ||
        this.detalleFormularioProveedor.cantidadHerramientas != null
          ? true
          : false;
      this.enBase.cantidadLlaves =
        this.detalleFormularioProveedor.cantidadLlaves == 0 ||
        this.detalleFormularioProveedor.cantidadLlaves != null
          ? true
          : false;
      this.enBase.cantidadLlavesDeRueda =
        this.detalleFormularioProveedor.cantidadLlaveDeRuedas == 0 ||
        this.detalleFormularioProveedor.cantidadLlaveDeRuedas != null
          ? true
          : false;
      this.enBase.cantidadPlacas =
        this.detalleFormularioProveedor.cantidadPlacas == 0 ||
        this.detalleFormularioProveedor.cantidadPlacas != null
          ? true
          : false;
    },
    getAsistencia(numAsistencia, showHelp = true) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (!numAsistencia) {
        router.push({ name: "login" }).catch(() => {});
      }

      axios
        .get(
          `api/FormularioFirma/${numAsistencia}/NumeroAsistencia`,
          this.$store.state.token ? configuracion : null,
        )
        .then((res) => {
          const info = res.data;
          if (info) {
            this.asistencia = info.asistencia;
            this.formulario = info.formulario;
            this.calidadFormularioProveedor = this.formulario.calidadFormularioProveedor;
            this.detalleFormularioProveedor = this.formulario.detalleFormularioProveedor;
            this.tercero = info.tercero;
            this.formulario.marcadoresVehiculo = JSON.parse(
              this.formulario.marcadoresVehiculo,
            );

            this.user = this.checkUserType();
            this.checkEnBase();

            if (
              (this.authUser &&
                this.$store.state.usuario.rol == "Operador Grua") ||
              (!this.authUser && this.user && showHelp)
            ) {
              this.mensajeDialog = true;
            }
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>
<style scoped></style>
